import React from 'react';
import UWWorkbook from '../components/uw/UWWorkbook';

/**
 * ErrorBoundary — catches render errors so we see the message instead of a blank page.
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }
  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }
  componentDidCatch(error, info) {
    console.error('[UWWorkbook Error]', error, info);
  }
  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: 40, fontFamily: 'monospace', background: '#fff1f0', minHeight: '100vh' }}>
          <h2 style={{ color: '#c0392b' }}>UW Workbook failed to render</h2>
          <pre style={{ fontSize: 13, color: '#333', whiteSpace: 'pre-wrap', wordBreak: 'break-all' }}>
            {String(this.state.error)}
          </pre>
          <button onClick={() => this.setState({ hasError: false, error: null })}
            style={{ marginTop: 16, padding: '8px 16px', cursor: 'pointer' }}>
            Retry
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

/**
 * UWWorkbookPage — route wrapper for the UW Workbook.
 * Renders without the standard Layout (full-screen, like Excel).
 */
export default function UWWorkbookPage() {
  return (
    <ErrorBoundary>
      <UWWorkbook />
    </ErrorBoundary>
  );
}
